(() => {
  const NEWSLETTER_ORIGIN_KEY = 'vaNewsletterOrigin';
  const FOOTER_FORM_ID = 'ContactFooter';
  const POPUP_STATE_KEY = 'vaNewsletterPopup';
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  /** フッターの表示幅に応じてメニューの開閉状態を同期する。 */
  const syncFooterMenus = (root) => {
    root.querySelectorAll('.c-footer__menu').forEach((menu) => {
      const isOpen = !mobileQuery.matches;
      const summary = menu.querySelector('.c-footer__menu-summary');

      menu.open = isOpen;
      menu.classList.toggle('c_accordion--open', isOpen);
      summary?.setAttribute('aria-expanded', String(isOpen));
    });
  };

  /** 現在表示されているすべてのフッターメニューを同期する。 */
  const syncAllFooterMenus = () => syncFooterMenus(document);

  /** フッターの送信元だけにニュースレター結果を表示する。 */
  const initFooterNewsletter = () => {
    const form = document.querySelector(`#${FOOTER_FORM_ID}`);
    if (!form) return;

    form.addEventListener('submit', () => {
      try {
        window.sessionStorage.setItem(NEWSLETTER_ORIGIN_KEY, FOOTER_FORM_ID);
      } catch (error) {}
    });

    const stateElement = form.querySelector('[data-newsletter-state]');
    if (!stateElement) return;

    let submittedFormId = window.location.hash.slice(1);
    if (!submittedFormId) {
      try {
        submittedFormId = window.sessionStorage.getItem(NEWSLETTER_ORIGIN_KEY) || '';
      } catch (error) {
        submittedFormId = '';
      }
    }
    if (submittedFormId && submittedFormId !== FOOTER_FORM_ID) {
      stateElement.hidden = true;
      const input = form.querySelector('input[name="contact[email]"]');
      input?.removeAttribute('aria-invalid');
      input?.removeAttribute('aria-describedby');
      return;
    }
    if (stateElement.dataset.newsletterState === 'success' && !window.Shopify?.designMode) {
      try {
        window.localStorage.setItem(
          POPUP_STATE_KEY,
          JSON.stringify({ state: 'subscribed', at: Date.now() }),
        );
      } catch (error) {}
    }
    const focusTarget = stateElement.dataset.newsletterState === 'error'
      ? form.querySelector('input[name="contact[email]"]')
      : stateElement;
    focusTarget?.focus({ preventScroll: true });
  };

  document.addEventListener('DOMContentLoaded', syncAllFooterMenus);
  document.addEventListener('DOMContentLoaded', initFooterNewsletter);
  document.addEventListener('shopify:section:load', (event) => syncFooterMenus(event.target));
  mobileQuery.addEventListener('change', syncAllFooterMenus);
})();
